<!--
 * @Author: mzw
 * @Date: 2025-04-21 09:15:08
 * @LastEditTime: 2025-05-09 14:53:25
 * @LastEditors: mzw
 * @Description: 物料助手-批任务模式-数据
-->
<template>
<div class="app-container">
  <div class="app-content-wrap">
    <el-header class="right-menu-name" height="40px">
      <el-breadcrumb separator="/" style="line-height:40px">
        <el-breadcrumb-item :to="{ name: 'materialAssistantBatch' }">批任务模式</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-header>
    <div class="container cf">
      <!-- <span v-if="isMineData" class="go-back" @click="goBack">
        <i class="el-icon-d-arrow-left"></i>
        返回
      </span> -->
      <el-tabs
        v-model="tagCode"
        @tab-click="handleClick"
        class="top-tab"
      >
        <el-tab-pane label="全部" name="all"></el-tab-pane>
        <el-tab-pane
          v-for="(tm,ti) in tagList"
          :key="ti"
          :label="tm.value"
          :name="tm.code"
        ></el-tab-pane>
      </el-tabs>
      <Search
        ref="searchRef"
        :searchConfig="searchConfig"
        @doSearch="doSearch"
        :resetEvent="true"
        @reset="resetHandle"
      >
        <template v-slot:btns>
          <el-button
            type="primary"
            @click="toggleExportTempV(true)"
            size="small"
          >导出</el-button>
          <ExportCom
            ref="ExportCom"
            :templateCodeList="[
              {
                code: 'AiUserMaterialAssistantTask1_1,AiUserMaterialAssistantTask1_0',
                value: '标准模板下载'
              },
              {
                code: 'AiUserMaterialAssistantTask0_1,AiUserMaterialAssistantTask0_0',
                value: '原文件下载'
              }
            ]"
            url="/help/export-log-mgmt/v1/sys-export-logs"
          />
          <!-- <el-button
            @click="exportBtnHistory"
            size="small"
          >导出历史</el-button> -->
          <el-button
            @click="viewRecords"
            size="small"
            style="margin-left: 6px;"
          >历史任务</el-button>
        </template>
      </Search>
      <Table
        ref="tableRef"
        :tableConfig="tableConfig"
        @handleSelectionChange="handleSelectionChange"
      >
        <template :slot="'inputInfo'" slot-scope="{ row }">
          <div class="custom-cell">
            <div>物料编码：{{row.originalMaterialCode || '-'}}</div>
            <div>物料描述：{{row.originalMaterialDesc || '-'}}</div>
            <div>规格：{{row.originalSpec || '-'}}</div>
            <div>型号：{{row.originalModel || '-'}}</div>
          </div>
        </template>
        <template :slot="'inputInfo2'" slot-scope="{ row }">
          <div class="custom-cell">
            <div>物料短名称：{{row.materialShortName || '-'}}</div>
            <div>物料长名称：{{row.materialLongName || '-'}}</div>
            <div>品牌名称：{{row.materialBrandName || '-'}}</div>
            <div>规格：{{row.materialSpec || '-'}}</div>
            <div>型号：{{row.materialModel || '-'}}</div>
          </div>
        </template>
        <template :slot="'bgCategoryName'" slot-scope="{ row }">
          <div class="custom-cell">
            <div>一级类目：{{row.firstCategoryName || '-'}}</div>
            <div>二级类目：{{row.secondCategoryName || '-'}}</div>
            <div>三级类目：{{row.thirdCategoryName || '-'}}</div>
          </div>
        </template>
        <template :slot="'inputInfo3'" slot-scope="{ row }">
          <div class="custom-cell">
            <el-popover
              placement="top-start"
              :width="200"
              trigger="hover"
              :disabled="!row.goodsPictureUrl"
            >
              <img :src="row.goodsPictureUrl" style="max-width: 100%"/>
              <template #reference>
                <div>
                  商品编码：
                  <span class="goods-code" @click="toGoodDetail(row)">{{row.goodsCode || '-'}}</span>
                  <span v-if="row.matchScore" class="goods-score"><b>{{row.matchScore}}</b>分</span>
                </div>
              </template>
            </el-popover>
            <div>商品名称：{{row.goodsName || '-'}}</div>
            <div>商品品牌：{{row.goodsBrand || '-'}}</div>
            <div>规格：{{row.goodsSpec || '-'}}</div>
            <div>型号：{{row.goodsModel || '-'}}</div>
          </div>
        </template>
        <template :slot="'tags'" slot-scope="{ row }">
          <div class="material-tags" v-if="row.tagCodeList && row.tagCodeList.length>0">
            <el-tag
              effect="plain"
              v-for="(mt,mi) in row.tagCodeList"
              :key="mi"
              :type="mt=='4' ? 'success' : 'danger' "
            >
              <!-- 标准商品(code='4')为绿色，其他都为红色 -->
              {{
                $getDictLabel('AI_MATERIAL_ASSISTANT_TAG', mt) ||
                '-'
              }}
            </el-tag>
          </div>
          <template v-else>-</template>
        </template>
        <template :slot="'matchedAttributes'" slot-scope="{ row }">
          {{ row.matchedAttributeList | getAttributeNames}}
        </template>
        <template :slot="'missingRate'" slot-scope="{ row }">
          {{ row.missingRate | formatePercent }}
        </template>
        <template :slot="'operation'" slot-scope="{ row }">
          <el-button
            type="text"
            @click="doEdit(row)"
          >编辑</el-button>
          <el-button
            type="text"
            @click="doDelete(row)"
            class="delete-btn"
          >删除</el-button>
        </template>
      </Table>

      <!-- 导出模板选择 -->
      <MaterialExport
        v-if="exportTempV"
        :visible="exportTempV"
        @toggleVisible="toggleExportTempV"
        :exportParams="exportParams"
      >
      </MaterialExport>
      <!-- 详情/编辑 -->
      <MaterialEdit
        v-if="detailEditV"
        :visible="detailEditV"
        :classificationTree="classificationTree"
        :taskDetailId="rowTaskDetailId"
        @toggleVisible="toggleDetailEditV"
        @editSuccess="detailEditSuccess"
      >
      </MaterialEdit>
      <!-- 历史任务 -->
      <MaterialRecords
        ref="recordsRef"
        @reload="reloadDetailList"
        :isMineData="isMineData"
      ></MaterialRecords>
    </div>
  </div>
</div>
</template>

<script>
import Search from '@/components/search/index';
import Table from '@/components/table/index';
import MaterialExport from "./components/MaterialExport.vue";
import MaterialEdit from "./components/MaterialEdit.vue";
import MaterialRecords from "./components/MaterialRecords.vue";
import { mul } from '@/utils/numberComputed';
import { openOther } from '@/utils/index';
import ExportCom from '@/components/exportCom/index';

export default {
  name: 'materialAssistantList',
  components: {
    Search,
    Table,
    MaterialExport,
    MaterialEdit,
    MaterialRecords,
    ExportCom
  },
  data () {
    const _this = this
    return {
      searchConfig: {
        params: [
          {
            prop: 'originalMaterialCode',
            label: '物料编码',
            placeholder: "物料编码"
          },
          {
            prop: "originalMaterialDesc",
            label: '物料描述',
            placeholder: "物料描述"
          },
          {
            prop: 'thirdCategoryIdList',
            label: '类目',
            placeholder: '类目',
            searchType: 'cascader',
            options: [],
            collapseTags: true,
            searchValueType: 'array',
            props: {
              label: 'name',
              value: 'backgroundCategoryId',
              multiple: true,
              // checkStrictly: true, //可选择任意一级
              emitPath: false
            },
          },
          {
            prop: "demandNameList",
            label: '需求名称',
            placeholder: "需求名称",
            searchType: 'multipleRemoteSelect',
            options: [],
            searchValueType: 'array',
            multipleRemoteSelected: [],
            queryStringLength: 1,
            searchProps: {
              url: '/help/ai/user/materialAssistant/demandNameListByPage', // 接口路径
              key: 'demandName', // 搜索字段
              extra: {
              },
              // 返回的是数组，直接展示数组元素、选中的数组元素直接传给后端，不用设置labelKey及valueKey
              // labelKey: ['companyName'], // 列表显示名称
              // valueKey: 'companyName', // 提交给后端的value
              resultListName: 'dataList',
              method: 'POST' // 请求方式
            }
          },
          {
            prop: 'taskNo',
            label: '任务号',
            placeholder: '任务号'
          }
        ]
      },
      tableConfig: {
        searchUrl: '/help/ai/user/materialAssistant/detail/listByPage', // 搜索接口
        searchMethod: 'POST', // 接口请求方式
        needPagination: true, // 是否需要分页
        // extra: {},
        autoSearch: false,
        fluidHeight: true, // 流体高度
        resultListName: 'dataList',
        // totalKey: "count",
        showCheckBox: true,
        checkSelectable:(row)=>{
          return true
        },
        params: [
          {
            prop: "inputInfo",
            label: "原始输入信息",
            width: '220',
            isSlot: true
          },
          {
            prop: "inputInfo2",
            label: "规范化描述",
            width: '220',
            isSlot: true
          },
          {
            prop: "bgCategoryName",
            label: "匹配类目",
            width: "160",
            isSlot: true
          },
          {
            prop: 'matchedAttributes',
            label: '匹配属性',
            width: "170",
            tips: '由AI自动解析输入信息与三级类目或者商品标准属性匹配所得，不保证100%准确，仅供参考',
            isSlot: true
          },
          {
            prop: 'missingAttributes',
            label: '缺失属性',
            minWidth: "170",
            showOverflowTooltip: true
          },
          {
            prop: 'missingRate',
            label: '缺失率',
            sortable: true,
            width: "90",
            isSlot: true
          },
          {
            prop: "inputInfo3",
            label: "推荐商品",
            width: '230',
            isSlot: true
          },
          {
            prop: "tags",
            label: "物料标签",
            width: '100',
            isSlot: true
          },
          {
            prop: "createTime",
            label: "导入时间",
            width: '160'
          },
          {
            prop: "operation",
            label: "操作",
            isSlot: true,
            width: "100",
            fixed: "right"
          }
        ]
      },
      isMineData: false, //仅个人数据
      classificationTree: [], // 类目
      tagList: [
        ...window.SITE_CONFIG.dictList.AI_MATERIAL_ASSISTANT_TAG
      ], // 标签
      tagCode: 'all', //tab选择 默认全部all
      selectedTaskDetailIds: [], //列表多选
      // 导出模板选择 && 导出历史
      exportTempV: false,
      exportParams: {
        getExportParams: () => {
          return {
            ..._this.$refs.searchRef.getParams(),
            ..._this.tableConfig.extra,
            taskDetailIdList: _this.selectedTaskDetailIds //多选选中行导出
          }
        }, // 搜索参数
      }, //导出参数
      recordsTempV: false, //历史任务
      //详情/编辑
      detailEditV: false,
      rowTaskDetailId: '',
    }
  },
  filters: {
    getAttributeNames(arr) {
      if(!arr || arr.length<=0) {
        return '-'
      }
      return arr.map(item=>{
        return item.attributeName
      }).join(',')
    },
    formatePercent(val) {
      if (val) {
        // 转换为%
        return mul(val, 100).toFixed(2) + '%'
      }
      return val === null||val ===undefined ? '-' : '0.00%'
    }
  },
  mounted () {
    Promise.all([
      this.getCategoryList()
    ]).then(() => {
      this.searchConfig.params.forEach((item, index) => {
        if (item.prop === 'thirdCategoryIdList') {
          item.options = this.classificationTree
        }
      })

      this.$nextTick(() => {
        this.doSearch()
      })
    })
  },
  methods: {
    // 搜索
    doSearch(params={}) {
      this.tableConfig.extra = {
        ...params,
        ...this.$refs.searchRef.getParams(),
        tagCode: (this.tagCode&&this.tagCode!='all') ? this.tagCode: null, //如果是全部'all' 传null
        createUserId: this.isMineData? this.$store.state.user.userId : null //是否仅查询个人数据
      };
      this.$refs.tableRef.getList();
    },
    // 重置
    resetHandle() {
      this.tagCode = 'all';
      this.$nextTick(()=>{
        this.doSearch()
      })
    },
    // tab切换
    handleClick() {
      this.$nextTick(()=>{
        this.doSearch()
      })
    },
    // 多选
    handleSelectionChange(val) {
      this.selectedTaskDetailIds = []
      val.forEach(item => {
        this.selectedTaskDetailIds.push(item.taskDetailId)
      });
    },
    // 导出模板选择 && 导出历史
    toggleExportTempV(flag) {
      this.exportTempV = flag
    },
    exportBtnHistory() {
      this.$refs.historydownloadlist.init();
    },

    //详情/编辑
    toggleDetailEditV(flag) {
      this.detailEditV = flag
    },
    doEdit(row) {
      this.rowTaskDetailId = row.taskDetailId
      this.toggleDetailEditV(true)
    },
    detailEditSuccess() {
      this.toggleDetailEditV(false)
      this.doSearch()
    },
    // 删除
    doDelete(row) {
      this.$http
        .post(`/help/ai/user/materialAssistant/detail/delete?taskDetailId=${row.taskDetailId}`)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.$message.success('删除成功')
          this.doSearch()
        })
    },

    // 历史任务
    viewRecords() {
      this.$refs.recordsRef.init({
        extra: { //额外参数
          
        }
      })
    },
    reloadDetailList(params) {
      this.$refs.searchRef.setField('taskNo', params.taskNo)
      this.$nextTick(()=>{
        this.doSearch()
      })
    },

    // 获取类目
    getCategoryList() {
      return this.$http
        .get('/front/commodity-center/manager/background-category/tree')
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          let data = JSON.stringify(res.data)
          data = data.replace(/"children":\[\]/g, '"children":null')
          this.classificationTree = JSON.parse(data)
        })
    },
    // 跳转
    toGoodDetail(row) {
      const spuId = row.spuId;
      this.$request
        .get(`/front/cross/commodity-user/spu-status/${spuId}`)
        .then((res) => {
          if(res==5){
            // 上架 跳转到商品详情页
            openOther(`goodDetail?spuId=${spuId}`)
          } else {
            // 下架
            this.$message.warning('该商品已下架，无法查看详情。');
            return
          }
        })
    },
    // 返回上一页
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang='scss' scoped>
.app-container {
  background: #f8f9fa;
  .app-content-wrap {
    width: 1200px;
    padding: 10px 0;
    margin: 0 auto;

    .right-menu-name {
      padding: 8px 16px;
      color: #999;
      font-weight: bold;

      i {
        margin: 0 3px;
        color: #666;
      }

      span {
        color: #333;
      }
    }
  }
}
.container {
  height: 800px;
  // margin-top: 20px;
  // width: 1200px;
  background: #fff;
  border-radius: 8px;
  padding: 20px 24px;
  .go-back{
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}

// .top-tab{
//   ::v-deep .el-tabs__header {
//     margin: 0;
//   }
// }

.material-tags {
  ::v-deep .el-tag {
    margin: 2px 0;
  }
}

.custom-cell {
  text-align: left;
  .goods-code {
    color: #1d65a8;
    cursor: pointer;
  }
  .goods-score {
    float: right;
  }
}
.delete-btn {
  color: #f56c6c;
}
</style>